"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";

interface BreadcrumbItem {
  label: string;
  link: string;
}

const Breadcrumbs: React.FC = () => {
  const [breadcrumbItems, setBreadcrumbItems] = useState<BreadcrumbItem[]>([]);

  useEffect(() => {
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    let link = "/";
    const generatedBreadcrumb: BreadcrumbItem[] = [];

    pathSegments.forEach((segment) => {
      link += `${segment}/`;
      const formattedSegment = segment
        .split("-")
        .map((part) => part.charAt(0).toLocaleUpperCase() + part.slice(1))
        .join(" ");

      generatedBreadcrumb.push({
        label: formattedSegment,
        link: link,
      });
    });

    setBreadcrumbItems(generatedBreadcrumb);
  }, []);

  return (
    <>
      <nav className="mb-20" aria-label="breadcrumb">
        <ol className="flex flex-wrap">
          <li className="mr-1.5">
            <Link
              href="/"
              className="hover:text-slate-200 focus-visible:text-slate-200 cursor-pointer"
            >
              Home
            </Link>{" "}
            /
          </li>
          {breadcrumbItems.map((item, index) => (
            <li className="mr-1.5" key={index}>
              <span>
                {index > 0 && " / "}
                {index === breadcrumbItems.length - 1 ? (
                  <span className="text-slate-200 font-bold">{item.label}</span>
                ) : (
                  <Link
                    href={item.link}
                    className="hover:text-slate-200 focus-visible:text-slate-200 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                )}
              </span>
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
